import storage from './storage';
import moment from 'moment';

export default {
    /**
     * 获取Token
     */
    getAccessToken() {
        let token = storage.get('token');

        // if (!token || !token.accessToken || !token.expired) {
        //     return false;
        // } else if (token.expired <= moment().unix()) {
        //     // 已过期，置换accessToken
        //     return false;
        // }
        if(!token) {
            return false;
        }
        return token;
    },

    /**
     * 保存token信息
     * 
     * @param {*} accessToken 访问凭证
     * @param {*} refreshToken 置换凭证
     * @param {*} expireTime 过期时间（秒）
     */
    refreshToken(accessToken, refreshToken, expireTime) {
        storage.set('token', {
            accessToken: accessToken,
            refreshToken: refreshToken,
            expired: moment().unix() + parseInt(expireTime) - 10
        })
    }
}


// WEBPACK FOOTER //
// ./src/fetch/accessToken.js